import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { fetchCategories } from '../services/api';

const CollectionsPreview = () => {
  const { language, t } = useLanguage();
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetchCategories().then(setCategories).catch(() => {});
  }, []);

  return (
    <section className="py-24 lg:py-32 bg-[#fffef2]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-light text-[#333333] mb-4 tracking-wide">
            {t('collections.title')}
          </h2>
          <p className="text-[#666666] text-base font-light">
            {t('collections.subtitle')}
          </p>
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {categories.map((category, index) => (
            <Link
              key={category.id}
              to={`/collections?category=${category.id}`}
              className="group relative overflow-hidden bg-[#f6f5e8] aspect-[4/5] transition-all duration-500 hover:shadow-lg"
              style={{ animationDelay: `${index * 150}ms` }}
            >
              {/* Image */}
              <img
                src={category.image}
                alt={category.name[language]}
                className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110"
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors duration-500" />
              {/* Content */}
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-6">
                <h3 className="text-2xl md:text-3xl font-light text-white mb-2 tracking-wide">
                  {category.name[language]}
                </h3>
                <p className="text-white/80 text-sm font-light mb-6">
                  {category.description[language]}
                </p>
                <span className="inline-flex items-center gap-2 text-white text-sm font-medium tracking-wider uppercase opacity-0 translate-y-4 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
                  {t('collections.viewAll')}
                  <ArrowRight className="w-4 h-4" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CollectionsPreview;
